module.exports = __webpack_public_path__ + "static/media/MyriadPro-Semibold.280c48bb.svg";